/**
 * JobStatusBadge Component
 * Displays job status with appropriate color coding using Tailwind CSS
 */

import React from 'react';
import { JobStatus } from '../../types/job';

interface JobStatusBadgeProps {
  status: JobStatus;
  className?: string;
}

const statusConfig: Record<JobStatus, { label: string; className: string }> = {
  [JobStatus.READY]: {
    label: 'Ready',
    className: 'bg-amber-100 text-amber-800',
  },
  [JobStatus.PROCESSING]: {
    label: 'Processing',
    className: 'bg-blue-100 text-blue-800',
  },
  [JobStatus.PROCESSED]: {
    label: 'Processed',
    className: 'bg-green-100 text-green-800',
  },
  [JobStatus.EXTRACTED]: {
    label: 'Extracted',
    className: 'bg-cyan-100 text-cyan-800',
  },
  [JobStatus.SUCCESS]: {
    label: 'Success',
    className: 'bg-emerald-100 text-emerald-800',
  },
  [JobStatus.ERROR]: {
    label: 'Error',
    className: 'bg-red-100 text-red-800',
  },
};

export const JobStatusBadge: React.FC<JobStatusBadgeProps> = ({ status, className = '' }) => {
  const config = statusConfig[status];

  if (!config) {
    return (
      <span className={`inline-flex items-center px-3 py-1 rounded-full text-xs font-semibold uppercase tracking-wide bg-gray-100 text-gray-800 ${className}`}>
        Unknown
      </span>
    );
  }

  return (
    <span
      className={`inline-flex items-center px-3 py-1 rounded-full text-xs font-semibold uppercase tracking-wide ${config.className} ${className}`}
    >
      {config.label}
    </span>
  );
};
